<template>
<div>

	<!-- wrapper to keep img and canvases the same size -->
	<div class='img-container' id='map-wrapper'>
		
		<!-- MAP -->
		<picture class='img' id='picture'>
			<source media="(orientation: portrait) and (min-width: 500px)" srcset="../assets/mapLong_large.png">
			<source media="(orientation: portrait)" srcset="../assets/mapLong_small.png">
			<source media="(min-width: 900px)" srcset="../assets/map_large.png">

			<img src="../assets/map_small.png" @load="handleMapLoad" >
		</picture>
	
		<!-- GRID OVERLAY -->
		<div class='overlay'>
			<Grid :config="gridConfig" :dims="dims" :numRows="numRows" :numCols="numCols" />
		</div>

		<!-- CELL OVERLAY -->
		<div class='overlay'>
			<Cells :config="cellConfig" :dims="dims" :numRows="numRows" :numCols="numCols" />
		</div>
	
	</div>

	<!-- CHART AND CONTOUR -->
	<div id='chart-wrapper'>
		<Chart :rawData="data" :config="chartConfig" :screenWidth="screenWidth" :screenHeight="screenHeight" :isPortrait="isPortrait" />
	</div>

	<div id='contour-wrapper'>
			<Contour :points="data" :config="contourConfig" :screenWidth="screenWidth" :screenHeight="screenHeight" :isPortrait="isPortrait" />
	</div>
	
</div>
</template>


<script>
import Grid from './Grid.vue';
import Cells from './Cells.vue';
import Chart from './Chart.vue';
import Contour from './Contour.vue';


export default {
	props: {
		screenWidth: Number,
		screenHeight: Number,
		isPortrait: Boolean,
		config: Object,
		data: Array
	},
	components: {
		Grid,
		Cells,
		Chart,
		Contour
	},
	watch: {
		screenWidth() {
			this.handleResize();
		},
		screenHeight() {
			this.handleResize();
		},
		config() {
			this.updateConfigs();
		},
	},
	mounted() {
		this.handleResize();
	},
	data() {
		return {
			mapLoaded: false,
			gridConfig: {},
			cellConfig: {},
			chartConfig: {},
			contourConfig: {},
			numRows: 0,
			numCols: 0,
			dims: {width: 0, height: 0}
		}
	},
	methods: {
		updateConfigs() {
			switch(this.config.target) {
				case 'grid':
					this.gridConfig = this.config;
					break;
				case 'cells': 
					this.cellConfig = this.config;
					break;
				case 'chart':
					this.chartConfig = this.config;
					break;
				case 'contour':
					this.contourConfig = this.config;
					break;
			}
		},
		handleMapLoad() {
			this.mapLoaded = true;
			this.handleResize();
			this.$emit('loaded');
		},
		handleResize() {
			// size canvases
			const parent = this.$el.querySelector('img');
			const dims = parent.getBoundingClientRect();
			const width = Math.floor(dims.width);
			const height = Math.floor(dims.height);
			this.dims = {
				width: width,
				height: height
			};

      // reset cols
      if (this.isPortrait) {
        this.numRows = 42;
        this.numCols = 9;
      } else {
        this.numRows = 9;
        this.numCols = 42;
      }
		}
	}
}

</script>